var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6616 12.6555C14.6616 13.365 12.9206 15.3518 9.72799 15.3518C6.53548 15.3517 4.72897 13.365 4.72897 12.6555V10.3147L9.01413 12.6555C9.43981 12.8897 9.95075 12.8897 10.3764 12.6555L14.6616 10.3147V12.6555ZM9.01413 4.17018C9.43969 3.94321 9.95082 3.94334 10.3764 4.17018L17.1313 7.8528C17.3581 7.98051 17.4994 8.21454 17.4995 8.47682V13.0247C17.4995 13.4148 17.1806 13.7346 16.7905 13.7346C16.4003 13.7346 16.0805 13.4149 16.0805 13.0247V8.83131L10.3764 11.9465C9.9508 12.1805 9.43972 12.1806 9.01413 11.9465L3.03366 8.68287C2.54412 8.41327 2.54412 7.70345 3.03366 7.43385L9.01413 4.17018Z",
    fill: "#84849A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandards);
export default __webpack_public_path__ + "static/media/standards.d9d1f005.svg";
export { ForwardRef as ReactComponent };